import { useEffect } from 'react';
import styles from './NoCurrentFloorFacilityPopup.module.scss';

type NoCurrentFloorFacilityPopupProps = {
  message: string;
  isOpen: boolean;
  clearPopupTimer: () => void;
};

const NoCurrentFloorFacilityPopup = ({ message, isOpen, clearPopupTimer }: NoCurrentFloorFacilityPopupProps) => {
  useEffect(() => {
    return () => {
      // 컴포넌트 언마운트 시 타이머 제거
      clearPopupTimer();
    };
  }, []);

  return (
    <div className={`${styles.container} ${isOpen ? styles.open : styles.close}`}>
      <div className={styles.text}>{message}</div>
    </div>
  );
};
export default NoCurrentFloorFacilityPopup;
